var CardSlider = function () {
	this.init = function () {
		$('[data-component="card-img-text"].slider').each(function() {
			if ($(this).children().length > 1) {
				$(this).slick({
					dots: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					arrows: false,
					autoplay: false,
					autoplaySpeed: 4000
				});
			}
		})

	}

	return this.init();
}
